import { c as _c } from "react/compiler-runtime";
import { COURSES_API } from 'modules/courses/courses/api/courses-api';
import { CourseFilterInterface } from 'modules/courses/courses/types/course-filter-interface';
import { CourseApiInterface } from 'modules/courses/courses/types/course-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import { coursesDependencies } from '../../constants/courses-dependencies';
interface UseCoursesInterface extends SwrPaginationInterface {
  filter: CourseFilterInterface;
}
export function useCourses(t0) {
  const $ = _c(12);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.search !== "" ? `&filter[searchBy]=${encodeURIComponent(filter.search)}` : ""}${filter.status !== undefined ? `&filter[isActive]=${filter.status}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== limit || $[3] !== pagination) {
    t2 = () => [`${COURSES_API}/list?${getPaginationQueryString({
      limit,
      pagination
    })}${filterApi}`, ...coursesDependencies];
    $[1] = filterApi;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: courses,
    mutate
  } = useControlledSwr(t2, fetcher, undefined, !!user);
  let t3;
  if ($[5] !== filterApi || $[6] !== user) {
    t3 = () => {
      if (user) {
        return [`${COURSES_API}/count?pagination[limit]${filterApi}`, ...coursesDependencies];
      }
      return null;
    };
    $[5] = filterApi;
    $[6] = user;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: counter
  } = useControlledSwr(t3, baseFetcher);
  let t4;
  if ($[8] !== counter || $[9] !== courses || $[10] !== mutate) {
    t4 = {
      courses,
      mutate,
      counter
    };
    $[8] = counter;
    $[9] = courses;
    $[10] = mutate;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}